import React from "react";
import GoodJobIcon from "../../../assets/images/goodJob.svg";
import images from "../../../assets/images";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getValidLandingScreen } from "../../../helpers/utils";
import { Button } from "../../../components/ds";

const GoalCompletionModal = ({
  questionTitle,
  questionData,
  handleCancel,
  handleOk,
  isAssessmentComplete,
}) => {
  const nextGoal = questionData?.next_goal;
  const history = useHistory();

  const saveProgress = () => {
    history.push(getValidLandingScreen());
    handleCancel();
  };

  return (
    <div className="good-job-modal-wrapper">
      {!isAssessmentComplete ? (
        <>
          <div>
            <img src={GoodJobIcon} alt="Good Job Icon" />
          </div>
          <div className="good-job-title"> Good Job!</div>

          <div className="good-job-description">
            You have successfully completed <b>{questionTitle}</b>
            <br />
            {nextGoal?.id && (
              <>
                Let’s go ahead and complete
                <b>
                  {nextGoal?.is_goal
                    ? nextGoal?.is_new_domain
                      ? ` Domain ${nextGoal?.domain_id}`
                      : ` Goal ${nextGoal?.order}`
                    : ` MIL ${nextGoal?.mil_no}`}
                </b>
              </>
            )}
          </div>
          <div className="modal-btn-group">
            <Button variant="secondary" onClick={saveProgress}>
              THAT’S IT FOR TODAY
            </Button>
            <Button
              variant="primary"
              onClick={nextGoal?.id ? handleOk : handleCancel}
            >
              {!nextGoal?.id ? "STAY HERE" : "PROCEED"}
            </Button>
          </div>
        </>
      ) : (
        <div className="assessment-completion">
          <div className="title-container">
            <img src={images.Party_Popper_Icon} alt="Celebration Icon" />
            <div className="good-job-title"> Congratulations!</div>{" "}
          </div>
          <div className="good-job-description">
            You have successfully completed the Cybersecurity Assessment.
          </div>
          <div className="modal-btn-group">
            <Button variant="secondary" onClick={handleCancel}>
              STAY HERE
            </Button>
            <Button variant="primary" onClick={saveProgress}>
              GO TO DASHBOARD
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default GoalCompletionModal;
